import type { RouteRecordRaw } from 'vue-router'

export const inventoryItemsRoute: RouteRecordRaw = {
  name: 'produtos-e-servicos',
  path: 'produtos-e-servicos',
  component: () => import('./pages/InventoryItemsPage.vue'),
}
